import React from 'react';
import clsx from 'clsx';
import useStyles from './styles';
import { StandardProps } from '@material-ui/core';

export type CenterClassKey = 'root' | 'inline' | 'viewport';

export type CenterProps = {
    /** Content that should be centered vertically and horizontally */
    children: React.ReactNode;

    /** Set to true to use inline-flex instead of flex */
    inline?: boolean;

    /** Set to true to use height: 100vh instead of viewport */
    viewport?: boolean;
};

const Center: React.FC<StandardProps<CenterProps, CenterClassKey>> = ({ className, children, inline, viewport }) => {
    const classes = useStyles();
    return (
        <div
            className={clsx(
                classes.root,
                {
                    [classes.inline]: inline,
                    [classes.viewport]: viewport,
                },
                className,
            )}
        >
            {children}
        </div>
    );
};

export default Center;
